// extracted by mini-css-extract-plugin
module.exports = {"tab":"sign-up-tab-module--tab--CX2K6","chevrons":"sign-up-tab-module--chevrons--3HfSg"};